//  Component: DeleteAuthor
//  Purpose: Manages Deletion of Author Status.

import React, { useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAuthorProfile, deleteAuthorProfileResponse } from "../../../../store/slices/authorProfile"

const DeleteAuthor = (props) => {
    const { id } = useParams();
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { deleteAuthorProfileDataLoading, deleteAuthorProfileData, deleteAuthorProfileError } = useSelector((state) => {
        return state.authorReducer; // Returning the desired state values
    });

    useEffect(() => {
        if (id) {
            dispatch(deleteAuthorProfile(id))
        }
        return () => {
            dispatch(deleteAuthorProfileResponse())
        }
    }, [])

    useEffect(() => {
        if (deleteAuthorProfileData) {
            setTimeout(() => {
                navigate(-1)
            }, 2000)
        }
    }, [deleteAuthorProfileData])

    return (

        <div className={"permission_denied"}>
            {(deleteAuthorProfileDataLoading) ?
                <>
                    {deleteAuthorProfileDataLoading && <h1>Deleting Author...</h1>}
                </>
                :
                <>
                    {
                        (deleteAuthorProfileData) &&
                        <div>
                            <h1>Deleted SuccessFully</h1>
                            <h5>Thank You!</h5>
                        </div>
                    }
                    {
                        (deleteAuthorProfileError) &&
                        <div className='text-danger'>
                            <h1>Deletion Failed</h1>
                            <h5>Please Try Again</h5>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default DeleteAuthor